import { NAVIGATED_TO_ZTSS } from '../constants/actions';

export function navigatedToZtss() {
  return { type: NAVIGATED_TO_ZTSS };
}
